export const environment = {
  production: false,
  // loginUrl : 'https://aidemo.callhealth.com/',
  // loginUrl : 'https://sdm.callhealth.com/login',
  baseUrl : 'https://chbus.callhealth.com/oms/api',
  busUrl:'https://chbus.callhealth.com',
  EncodeKey: "0123456789abcdef0123456789abcdef",
  EncodeIVKey: "0123456789abcdef",
  routingUrl:'https://chrouting.callhealth.com',
  googleApiKey: 'AIzaSyDdBOhh1q07dhphxKkOOiOwzPAFWSLqXks',
  loginUrl : 'https://sdm.callhealth.com/login',
  // baseUrl : 'https://orm.callhealth.com/OMS/api/operation.php/v1/orderswithcount',
  getAssociates : 'https://orm.callhealth.com/OMS/api/operation.php/v1/fetch_nearby_associates',
  getOfficers : 'https://orm.callhealth.com/OMS/api/operation.php/v1/fetch_officers',
  orderAllocation : 'https://orm.callhealth.com/OMS/api/operation.php/v1/orderallocation',
  tenantList : 'https://orm.callhealth.com/OMS/api/operation.php/v1/get/list/tenants',
  tenatOrganisationList : 'https://orm.callhealth.com/OMS/api/operation.php/v1/fetch/org/list/tenantcodes',
  refundOrders : 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/refund',
  receiptBill : 'https://orm.callhealth.com/OMS/api/operation.php/v1/BillInfo',
  refundInfo : 'https://orm.callhealth.com/OMS/api/operation.php/v1/update/refund/info',
  instantRefund : 'https://orm.callhealth.com/OMS/api/operation.php/v4/refund/to/source',
  rejectRefund : 'https://orm.callhealth.com/OMS/api/operation.php/v1/generateTicket',
  fetchBusinesses : 'https://orm.callhealth.com/OMS/api/operation.php/v1/fetchBusinesses',
  getCategorySubCataegory : 'https://orm.callhealth.com/OMS/api/operation.php/v1/requestForCallbackMdm',
  getReimburseDataByTenantOrg : 'https://entitlements.callhealth.com/reimburse/getReimburseDataByTenantOrg',
  viewReimburse : 'https://entitlements.callhealth.com/reimburse/viewReimburse',
  reimburseStatusList : 'https://entitlements.callhealth.com/reimburse/getReimburseStatusList',
  reimburseStatusUpdate : 'https://entitlements.callhealth.com/reimburse/updateReimburseStatus',
  downloadDoc:'https://chrouting.callhealth.com/uploadutils/docUtils/documet/downloadLink?documentId=',
  invoiceDownload:'https://orm.callhealth.com/OMS/api/operation.php/v1/invoice?OrderID=',
  prescriptionPrint:'https://orm.callhealth.com/OMS/api/operation.php/v1/prescriptionprint?OrderID=',
  sampleCollection:'https://orm.callhealth.com/OMS/api/operation.php/v1/sampleCollectionMemo?OrderID=',
  otpUrl: 'https://callhealth.com/rest/GenericAPIs',
  baseUrlDate: 'https://chiss.callhealth.com/api/aposlots',
  getDoctors: 'https://chbus.callhealth.com/edm/getDoctors',
  updateDoctor: 'https://chbus.callhealth.com/oms/updateDoctor',
  dynamicUrlDate: 'https://chbus.callhealth.com/chiss/getTimeSlots',
  sessionValidationUrl: 'https://officeraccount.callhealth.com/api/validateSessionKey',
  reScheduleOrderUrl: 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/change/status',
  userInfoUrl: 'https://orm.callhealth.com/OMS/api/auth.php/v1/gettokendata',
  tokenUrl: 'https://officeraccount.callhealth.com/api/validateSessionKey',
  changeStatusBasedOnPrescriptionUrl: 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/change/status',
  cancelOrderUrl: 'https://orm.callhealth.com/OMS/api/operation.php/v1/orderCancel',
  rejectOrderUrl: 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/change/status',
  sampleSubmission : 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/processing/sample_submission',
  uploadFileUrl: 'https://orm.callhealth.com/OMS/api/uploader.php/v4/orders/report/upload',
  uploadPrescriptionUrl: "https://orm.callhealth.com/OMS/api/uploader.php/v4/orders/prescriptions/upload",
  cancelationTypeUrl: 'https://chrouting.callhealth.com/mdm/reasons/getAll/CancellationType?code=ALL',
  getDocumentUrl: 'https://chrouting.callhealth.com/uploadutils/docUtils/documet/downloadLink?documentId=',
  prescriptionUrl :'https://orm.callhealth.com/OMS/api/operation.php/v1/orders/notification/send/prescription-upload-link',
  paymentDifferenceUrl : 'https://orm.callhealth.com/OMS/api/operation.php/v1/orders/payments/link/send',
  confirmationOrderUrl : 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/change/status',
  reAlocationUrl :'https://orm.callhealth.com/OMS/api/operation.php/v4/vendor/reallocation',
  testNameApiUrl : 'https://callhealthc.om/rest/MDMDataAPIs',
  addItemApiUrl : 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/lineitem/crud/multi',
  deleteItemApiUrl : 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/lineitem/crud',
  reAssignItemApi : 'https://callhealth.com/rest/MDMDataAPIs',
  getLineItmDetailsUrl : 'https://chrouting.callhealth.com/mdm/fetchService/GetLineItemByServiceCodes',
  changeStatusUrl : 'https://orm.callhealth.com/OMS/api/operation.php/v1/order/change/status',
  clearSessionUrl : 'https://orm.callhealth.com/OMS/api/auth.php/v1/deletehelptoken',
  diagnosticCenterApiUrl : 'https://pe.callhealth.com/api/searchPatnersByBusiness',
  cancelReasonUrl :'https://callhealth.com/rest/MDMDataAPIs',
  // externalOtpVerifyApiUrl : 'http://3.7.163.198:8080/callhealth/validate-otp',
  downloadFileUrl:'https://orm.callhealth.com/OMS/api/uploader.php/v4/orders/document/id',
  finalReportSent:'https://orm.callhealth.com/OMS/api/uploader.php/v6/report/resend',
  externalOtpVerifyApiUrl : 'https://chgateway.callhealth.com/api/validatedrlotp',
  orderTrackApiUrl : ' https://orm.callhealth.com/OMS/api/operation.php/v1/ordertrack',
  deletePrescriptionUrl: 'https://orm.callhealth.com/OMS/api/uploader.php/v4/orders/prescriptions/delete',
  apiKey: '31DEM-D42WA-P1144-ERD131-1ERT1',
  labTimingApiUrl: 'https://orm.callhealth.com/OMS/api/operation.php/v4/fetch/lab/timings',
  vendorListUrl:'https://orm.callhealth.com/OMS/api/medicine_supply.php/v1/vendor_list',
  assignVendorUrl:'https://orm.callhealth.com/OMS/api/operation.php/v1/order/change/status',
  escalationCancelOrderUrl:'https://orm.callhealth.com/OMS/api/operation.php/v1/orders/cancel/manually',
  tenantCodesDrl: ['1000143'],
  orgCodesDrl:  ['100229'],
  ch_app_access_token : "PeThWmZq4t6w9z$C&F)J@NcRfUjXn2r5u8x!A%D*G-CALLaPdSgVkYp3s6v9N$B?E(H+MbQeThWmZq4t7w!z%C*F)J@Healthr5u8x/A?D(G+KbPdSgVkYp3s6v9y$UY$"

};
